<template>
	<div>
		<nav class="navbar">
			<div class="d-flex align-items-center px-2">
				<div class="backlink" v-if="backlink">
					<router-link tag="a" :to="backlink" class="btn btn-back btn-light">
						<i class="icon icon-arrow-left"></i
					></router-link>
				</div>

				<div class="title">
					<h1>{{ pageTitle }}</h1>
					<p v-if="pageSubtitle">{{ pageSubtitle }}</p>
				</div>

				<div class="btn-menu-toggle">
					<div class="btn btn-menu-toggle" @click="opened = !opened">
						<div class="icon icon-menu"></div>
					</div>
				</div>
			</div>

			<div class="d-flex flex-grow-1 align-items-center justify-content-end">
				<div>
					<slot name="bar"></slot>
				</div>

				<div class="d-flex w-100 align-items-center justify-content-end">
					<b-dropdown block right variant="text" class="only-desktop user-dropdown">
						<template v-slot:button-content class="dropdown-user">
							<div
								class="avatar"
								:style="{
									backgroundImage: `url('${require('@/assets/img/no-avatar-image.gif')}')`
								}"
							></div>
							<div class="username">{{ loggedUser.name }} {{ loggedUser.lastname }}</div>
						</template>
						<router-link tag="b-dropdown-item" to="/account">
							Mi cuenta
						</router-link>
						<router-link tag="b-dropdown-item" to="/settings">
							Configuraciones
						</router-link>
						<router-link tag="b-dropdown-item" to="/logout">Salir</router-link>
					</b-dropdown>
				</div>
			</div>
		</nav>

		<div class="nav-spacer"></div>

		<div class="sidebar-wrapper" :class="{ opened: opened }">
			<div class="p-3">
				<img src="@/assets/logo.png" alt="" class="logo mr-4" />
			</div>

			<div class="head only-mobile">
				<b-dropdown block right>
					<template v-slot:button-content class="dropdown-user">
						<div
							class="avatar"
							:style="{
								backgroundImage: `url('${require('@/assets/img/no-avatar-image.gif')}')`
							}"
						></div>
						{{ loggedUser.name }} {{ loggedUser.lastname }}
					</template>
					<b-dropdown-item href="#">An item</b-dropdown-item>
					<router-link tag="b-dropdown-item" to="/logout">Salir</router-link>
				</b-dropdown>
			</div>

			<div class="list-group list-group-flush mt-2 flex-grow-1">
				<router-link
					to="/"
					:class="{ selected: $route.meta.section == 'dashboard' }"
					class="list-group-item list-group-item-action"
				>
					<div class="icon">
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4 4H9V9H4V4ZM2 11V2H11V11H2ZM4 15H9V20H4V15ZM2 22V13H11V22H2ZM20 15H15V20H20V15ZM13 13V22H20C21.1046 22 22 21.1046 22 20V13H13ZM15 4H20V9H15V4ZM13 11V2H22V11H13Z"
								fill="currentColor"
							></path>
						</svg>
					</div>
					<span>Dashboard</span>
				</router-link>

				<router-link
					to="/events"
					:class="{ selected: $route.meta.section == 'events' }"
					class="list-group-item list-group-item-action"
				>
					<div class="icon">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M15 19.9995H17V13.9995H15V11.9995H17V3.99951H15C15 5.65951 13.649 6.99951 12 6.99951C10.34 6.99951 9 5.65951 9 3.99951H7V11.9995H9V13.9995H7V19.9995H9C9 18.3395 10.35 16.9995 12 16.9995C13.66 16.9995 15 18.3395 15 19.9995ZM13 3.99951V1.99951H19V19.9995C19 21.1095 18.1 21.9995 17 21.9995H13V19.9995C13 19.4495 12.55 18.9995 12 18.9995C11.45 18.9995 11 19.4495 11 19.9995V21.9995H5V1.99951H11V3.99951C11 4.55051 11.45 4.99951 12 4.99951C12.55 4.99951 13 4.55051 13 3.99951ZM13.9971 14.0008H9.99707V12.0008H13.9971V14.0008Z"
								fill="currentColor"
							></path>
						</svg>
					</div>
					<span>Eventos y entradas</span>
				</router-link>

				<router-link
					to="/memberships"
					:class="{ selected: $route.meta.section == 'memberships' }"
					class="list-group-item list-group-item-action"
				>
					<div class="icon">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
							<path
								fill="currentColor"
								fill-rule="evenodd"
								d="M16.85,7.275l-3.967-0.577l-1.773-3.593c-0.208-0.423-0.639-0.69-1.11-0.69s-0.902,0.267-1.11,0.69L7.116,6.699L3.148,7.275c-0.466,0.068-0.854,0.394-1,0.842c-0.145,0.448-0.023,0.941,0.314,1.27l2.871,2.799l-0.677,3.951c-0.08,0.464,0.112,0.934,0.493,1.211c0.217,0.156,0.472,0.236,0.728,0.236c0.197,0,0.396-0.048,0.577-0.143l3.547-1.864l3.548,1.864c0.18,0.095,0.381,0.143,0.576,0.143c0.256,0,0.512-0.08,0.729-0.236c0.381-0.277,0.572-0.747,0.492-1.211l-0.678-3.951l2.871-2.799c0.338-0.329,0.459-0.821,0.314-1.27C17.705,7.669,17.316,7.343,16.85,7.275z M13.336,11.754l0.787,4.591l-4.124-2.167l-4.124,2.167l0.788-4.591L3.326,8.5l4.612-0.67l2.062-4.177l2.062,4.177l4.613,0.67L13.336,11.754z"
							></path>
						</svg>
					</div>
					<span>Membresias</span>
				</router-link>

				<router-link
					to="/transactions"
					:class="{ selected: $route.meta.section == 'transactions' }"
					class="list-group-item list-group-item-action "
				>
					<div class="icon">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path
								fill="currentColor"
								fill-rule="evenodd"
								d="M20 4c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2h-2v-2h2v-7H4v7h8.586l-1.293-1.293c-.36-.36-.388-.928-.083-1.32l.083-.094c.36-.36.928-.388 1.32-.083l.094.083 3 3c.36.36.388.928.083 1.32l-.083.094-3 3c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L12.584 20H4c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h16zM9 13c.552 0 1 .448 1 1s-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1h2zm11-7H4v2h16V6z"
							></path>
						</svg>
					</div>
					<span>Cobros</span>
				</router-link>

				<router-link
					to="/withdraws"
					:class="{ selected: $route.meta.section == 'withdraw' }"
					class="list-group-item list-group-item-action "
				>
					<div class="icon">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<line x1="3" y1="21" x2="21" y2="21"></line>
							<line x1="3" y1="10" x2="21" y2="10"></line>
							<polyline points="5 6 12 3 19 6"></polyline>
							<line x1="4" y1="10" x2="4" y2="21"></line>
							<line x1="20" y1="10" x2="20" y2="21"></line>
							<line x1="8" y1="14" x2="8" y2="17"></line>
							<line x1="12" y1="14" x2="12" y2="17"></line>
							<line x1="16" y1="14" x2="16" y2="17"></line>
						</svg>
					</div>
					<span>Retiros</span>
				</router-link>

				<router-link
					to="/reports"
					:class="{ selected: $route.meta.section == 'reports' }"
					class="list-group-item list-group-item-action "
				>
					<div class="icon">
						<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M15 2.22302C18.3648 2.98652 21.0135 5.63525 21.777 9C21.9229 9.64322 22 10.3126 22 11H20H15H13V9V4V2C13.6874 2 14.3568 2.07706 15 2.22302ZM15 4.28988C17.2578 4.96183 19.0382 6.74222 19.7101 9L15 9V4.28988ZM11 6.0164V4.94842L9.93432 5.01856C5.50314 5.31022 2 8.9956 2 13.5C2 18.1944 5.80558 22 10.5 22C15.0044 22 18.6898 18.4969 18.9814 14.0657L19.0516 13H17.9836H11V6.0164ZM4 13.5C4 10.4265 6.13363 7.85072 9 7.17379V14V15H10H16.8262C16.1493 17.8664 13.5735 20 10.5 20C6.91015 20 4 17.0899 4 13.5Z"
								fill="currentColor"
							></path>
						</svg>
					</div>
					<span>Informes</span>
				</router-link>
				<!-- <router-link to="/memberships" :class="{ selected: $route.meta.section == 'memberships' }" class="list-group-item list-group-item-action pl-4">
					<span>Retiros</span>
				</router-link>
				<router-link to="/memberships" :class="{ selected: $route.meta.section == 'memberships' }" class="list-group-item list-group-item-action pl-4">
					<span>Informes</span>
				</router-link> -->
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	name: "Navbar",
	props: {
		hideSidebar: {
			type: Boolean,
			default: false
		},
		backlink: { default: "" },
		pageTitle: { default: "" },
		pageSubtitle: { default: "" }
	},
	data() {
		return {
			opened: false,
			unreadCounter: 0,
			appVersion: process.env.VUE_APP_VERSION
		}
	},
	computed: {
		...mapGetters(["loggedUser"])
	}
}
</script>
<style>
.btn-back {
	background-color: #fff;
	border: none;
	margin-left: 0px;
	margin-top: -2px;
	height: 36px;
}
.btn-back .icon {
	width: 10px;
}

.navbar .title {
	flex-grow: 1;
	margin-right: 12px;
}
.navbar .title h1 {
	font-size: 1.3125rem;
	font-weight: 500;
}
.navbar .title p {
	font-size: 0.9rem;
	font-weight: 400;
	margin: 0px;
}

.navbar {
	padding: 0px 8px;
	width: calc(100% - 256px);
	height: 58px;
	top: 0px;
	left: 256px;
	background-color: #fff;
	z-index: 150;
	position: fixed;
}
.navbar .btn-menu-toggle {
	color: #080808;
	display: none;
}
.navbar .btn-menu-toggle .icon {
	display: flex;
	align-items: center;
	justify-content: center;
}

.only-mobile {
	display: none;
}
.only-desktop {
	display: initial;
}

@media (max-width: 991px) {
	.navbar {
		width: 100%;
		left: 0px;
	}
	.navbar .btn-menu-toggle {
		display: inline-block;
	}

	.only-mobile {
		display: initial;
	}
	.only-desktop {
		display: none;
	}
}

.nav-spacer {
	width: 100%;
	height: 58px;
}
.navbar .logo {
	max-width: 90px;
}
.navbar .nav-item .nav-link {
	min-height: 60px;
	line-height: 60px;
	padding: 0px;
	margin: 0px 14px;
	color: #333;
}

.sidebar-wrapper {
	width: 256px;
	height: 100%;
	overflow: hidden;
	top: 0;
	left: 0;
	z-index: 1000;
	position: fixed;
	color: #000;
	background-color: #fff;
	transition: all 0.3s ease-in-out;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	display: flex;
	flex-direction: column;
	box-shadow: rgb(29 33 41 / 5%) 0px 2px 12px, rgb(29 33 41 / 12%) 0px 1px 3px;
}

@media (max-width: 991px) {
	.sidebar-wrapper {
		top: 58px;
		height: calc(100% - 58px);
		left: -290px;
		-webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
		-moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
		box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
	}
}
.sidebar-wrapper.opened {
	left: 0px !important;
}

.sidebar-wrapper .logo {
	max-width: 154px;
}

.sidebar-wrapper .head {
	height: 64px;
	font-size: 14px;
	font-weight: normal;
	line-height: 20px;
	padding: 8px;
}

.sidebar-wrapper .list-group {
	width: 100%;
	overflow: auto;
	padding: 16px;
	max-height: calc(100% - 112px);
	display: block;
	background-color: inherit;
}
.sidebar-wrapper .list-group .list-group-item {
	display: flex;
	font-size: 14px;
	line-height: 20px;
	font-weight: 500;
	border-radius: 3px;
	padding: 8px 12px;
	margin-bottom: 8px;
	height: 40px;
	border: none;
	align-items: center;
	color: #333;
}
.sidebar-wrapper .list-group .list-group-item:hover {
	color: rgb(16, 22, 35);
	background-color: rgb(243, 243, 244);
}

.sidebar-wrapper .list-group .list-group-item .icon {
	width: 24px;
	height: 24px;
	display: flex;
	margin-right: 12px;
	justify-content: center;
	align-items: center;
	text-align: center;
	flex-shrink: 0;
}
.sidebar-wrapper .list-group .list-group-item .icon i {
	color: inherit;
	font-size: 12px;
}
.sidebar-wrapper .list-group .list-group-item span {
	flex-grow: 1;
}
.sidebar-wrapper .list-group .list-group-item .expand {
	width: 54px;
	text-align: center;
	display: inline-block;
}
.sidebar-wrapper:hover .list-group .list-group-item span {
	opacity: 1;
}

.list-group-item.expandible:not(.collapsed) {
	background-color: #0e2542 !important;
}
.sidebar-wrapper .list-group .list-group-item-child {
	padding-left: 54px;
	height: 34px;
	line-height: 34px;
	background-color: #0e2542;
}
.sidebar-wrapper .list-group .list-group-item-child:hover {
	background-color: #0f2f56;
}
.sidebar-wrapper .list-group .list-group-item.selected {
	color: rgb(255, 255, 255);
	background-color: rgb(0, 112, 246);
}

.sidebar-wrapper h3 {
	font-size: 12px;
	text-transform: uppercase;
	padding: 20px 0px 0px 12px;
	margin: 0px;
	opacity: 0.5;
}

.list-group-item.collapsed .expand.when-open,
.list-group-item:not(.collapsed) .expand.when-closed {
	display: none;
}

.sidebar-wrapper .dropdown {
	width: 100%;
}
.sidebar-wrapper .btn.dropdown-toggle {
	height: 58px;
	background-color: #143155;
	color: #fff;
	display: flex;
	align-items: center;
	border: none;
	border-radius: 0px;
	font-size: 12px;
}

.sidebar-wrapper .dropdown .btn:hover {
	background-color: #133c6f;
}
.sidebar-wrapper .avatar {
	width: 32px;
	height: 32px;
	background-color: #f2f2f2;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	border-radius: 50%;
	margin-right: 8px;
}

.navbar .user-dropdown {
	position: relative;
}
.navbar .user-dropdown .btn.dropdown-toggle {
	/* height:58px; */
	position: relative;
	background-color: #fff;
	color: #000;
	display: flex;
	align-items: center;
	border: none;
	border-radius: 0px;
	font-size: 12px;
}
.navbar .user-dropdown .btn.dropdown-toggle .avatar {
	width: 32px;
	height: 32px;
	border: 1px solid #d8d8d8;
	background-color: #f2f2f2;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	border-radius: 50%;
	margin-right: 8px;
}
.navbar .user-dropdown .btn.dropdown-toggle .username {
	line-height: 14px;
	text-align: left;
	padding-right: 4px;
}

.icons-reminders {
	padding: 0px 16px;
	display: inline-flex;
	align-items: center;
}

.btn-header {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32px;
	height: 32px;
	text-align: center;
	color: #78858a;
	border: 1px solid #d3d9db;
	border-radius: 100%;
	position: relative;
	margin: 0px 14px 0px 8px;
}
.btn-header .icon {
	font-size: 16px;
}
.btn-header .badge {
	border: solid 2px #fff;
	position: absolute;
	top: -6px;
	right: -10px;
	width: 20px;
	height: 20px;
	display: block;
	justify-content: center;
	align-items: center;
	padding: 0px;
	font-size: 10px;
	line-height: 17px;
	font-weight: 500;
}

.env-alert {
	display: flex;
	height: 22px;
	align-items: center;
	border-radius: 15px;
	padding: 4px 12px;
}

.navbar .filters-box {
	padding: 0px;
}
.navbar .filters-box .filter-input {
	width: 380px;
	border: none !important;
	background-color: #f1f3f4 !important;
}
.navbar .filters-box .icon {
	font-size: 18px;
}
</style>
